import { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../services/firebase";
import bcrypt from "bcryptjs";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { useOperator } from "../contexts/OperaotrContext.jsx";


const Register = () => {
  const [mobile, setMobile] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpId, setOtpId] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { updateOperator } = useOperator();

  // Send OTP via Cloud Function (MSG91 SMS)
  const sendOtp = async () => {
    if (mobile.length !== 10 || isNaN(mobile)) {
      alert("Enter a valid 10-digit mobile number");
      return;
    }

    setLoading(true);
    try {
      // 1. Check if operator already exists
      const q = query(
        collection(db, "operator"),
        where("mobile", "==", mobile),
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        alert("This mobile number is already registered as an operator.");
        setLoading(false);
        return;
      }

      // 2. Trigger Cloud Function
      const functions = getFunctions(undefined, "us-central1");
      const sendOTP = httpsCallable(functions, "sendOTP");

      const result = await sendOTP({
        mobile,
        useCase: "REGISTRATION", // Uses JMI_REGESTRION_OTP
      });

      // 3. Store returned otpId for verification
      setOtpId(result.data.otpId);
      setOtpSent(true);

      alert(`✅ OTP sent to +91 ${mobile} successfully.`);
    } catch (err) {
      console.error("Error sending OTP:", err);
      alert(err.message || "Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

   // Verify OTP via Cloud Function and create operator account
  const verifyOtpAndRegister = async () => {
    if (!otp || !password || !confirmPass) {
      alert("Please fill all fields");
      return;
    }

    if (password !== confirmPass) {
      alert("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      // 1. Verify OTP with Cloud Function
      const functions = getFunctions(undefined, "us-central1");
      const verifyOTP = httpsCallable(functions, "verifyOTP");

      const verifyResult = await verifyOTP({
        otpId: otpId || `+91${mobile}_JMI_REGISTRATION_OTP`,
        otp: otp.trim(),
      });

      if (!verifyResult.data.success) {
        alert("OTP verification failed. Please try again.");
        setLoading(false);
        return;
      }

      // 2. Generate unique operator ID
      const operatorId = "OP-" + uuidv4().split("-")[0].toUpperCase();
      const passwordHash = await bcrypt.hash(password, 10);
      updateOperator({ OperatorId: operatorId });

      // 3. Save operator in 'operator' collection
      await setDoc(doc(db, "operator", mobile), {
        operatorId,
        mobile,
        passwordHash,
        createdAt: new Date(),
        status: "active",
      });

      alert(`🎉 Operator registered successfully!\nYour ID: ${operatorId}`);
      nav("/operatorRegistration");
    } catch (err) {
      console.error("Operator registration error:", err);
      // Handles 'invalid', 'expired', 'already-verified' errors from Cloud Function
      if (err.message.includes("expired")) {
        alert("OTP has expired. Please request a new one.");
        setOtpSent(false);
      } else if (err.message.includes("Invalid OTP")) {
        alert("Invalid OTP. Please check and try again.");
      } else {
        alert(err.message || "Something went wrong during registration. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="login-wrapper">
      <h1 className="title">JMI</h1>
      <p className="subtitle">Operator Desk</p>
      <div className="login-box">
        <h2>Registration</h2>
        <label>Operator Mobile</label>
        <input
          type="tel"
          maxLength="10"
          placeholder="Enter Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
          disabled={otpSent}
        />
        {!otpSent ? (
          <button className="login-btn" onClick={sendOtp} disabled={loading}>
            {loading ? "Generating OTP..." : "Send OTP"}
          </button>
        ) : (
          <>
            <label>OTP</label>
            <input
              type="text"
              placeholder="Enter OTP (sent via WhatsApp)"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <label>Password</label>
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <label>Confirm Password</label>
            <input
              type="password"
              placeholder="Confirm password"
              value={confirmPass}
              onChange={(e) => setConfirmPass(e.target.value)}
            />

            <button
              className="login-btn"
              onClick={verifyOtpAndRegister}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify & Register"}
            </button>
          </>
        )}
      </div>

      <p className="register-link">
        Already have an account?{" "}
        <span onClick={() => nav("/operatorlogin")}>Login</span>
      </p>

      <p className="support">
        <img src="/whatsapp.svg" alt="whatsapp" className="whatsapp-icon" />
        <span
          onClick={() => window.open("https://wa.me/918917412728", "_blank")}
        >
          {" "}
          Need help?{" "}
        </span>
        Contact Support
      </p>

      {/* Keep for compatibility (though unused) */}
      <div id="recaptcha-container"></div>
    </div>
  );
};

export default Register;
